import { PaymentStatus } from 'enums';

const paidStatus = PaymentStatus.Paid.toLowerCase();

export const isPaidDeduction = (statusDescription?: string): boolean =>
    statusDescription?.trim().toLowerCase() === paidStatus;
